<template>
  <div>
    <div class="child-header mb-4">
      <template v-if="children.length == 1">
        <div v-if="children.length == 1" class="user-photo">
          <user-icon
            :id="children[0].id"
            :show-inline="true"
            :name="children[0].name"
            :short-name="children[0].shortName"
            :picture-object="children[0].profilePicture"
          />
        </div>
        <div v-if="children.length == 1" class="child-check-in">
          <div class="child-name">
            {{ $getProfileDisplayName(children[0]) }}<br />
            <b-btn
              :variant="isEmployeeDashboard ? 'primary' : 'white'"
              :disabled="isUpdating"
              class="btn-update-status"
              data-testid="update-status-button"
              @click="handleUpdateChildStatus()"
            >
              {{ setStatusButtonText }}
            </b-btn>
          </div>
        </div>
      </template>
      <template v-else>
        <span v-for="child in children" :key="child.id" class="child">
          {{ $getProfileDisplayName(child) }}
          <b-btn
            variant="link"
            class="remove-child"
            :aria-label="$getText('ARIA_LABEL_PRESENCE_DASHBOARD_REMOVE_CHILD')"
            @click="removeChild(child)"
          >
            <i class="icon-Aula_close" />
          </b-btn>
        </span>
      </template>
    </div>
    <div v-if="children.length > 1" class="update-status">
      <b-btn variant="primary" class="btn-update-status" @click="updateChildStatus(presenceStates.PRESENT, true)">
        {{ $getText('PRESENCE_STATUS_CHECK_IN') }}
      </b-btn>
      <b-btn variant="primary" class="btn-update-status" @click="updateChildStatus(presenceStates.CHECKED_OUT, true)">
        {{ $getText('PRESENCE_STATUS_CHECK_OUT') }}
      </b-btn>
    </div>
  </div>
</template>
<script>
import { presenceStates } from '../../enums/presenceStates';

export default {
  props: {
    children: { type: Array },
    status: { type: Number },
    isUpdating: { type: Boolean, default: false },
    isEmployeeDashboard: { type: Boolean, default: false },
  },
  data: function () {
    return {
      presenceStates: presenceStates,
    };
  },
  computed: {
    isChildAbsent() {
      const absentStates = [
        this.presenceStates.NOT_PRESENT,
        this.presenceStates.CHECKED_OUT,
        this.presenceStates.SICK,
        this.presenceStates.REPORTED_ABSENT,
      ];
      return absentStates.includes(this.status);
    },
    childStatus() {
      return this.isChildAbsent ? this.presenceStates.PRESENT : this.presenceStates.CHECKED_OUT;
    },
    setStatusButtonText() {
      return this.isChildAbsent ? this.$getText('PRESENCE_CHECK_IN') : this.$getText('PRESENCE_CHECK_OUT');
    },
  },
  methods: {
    removeChild(child) {
      this.$emit('removeChild', child);
    },
    updateChildStatus(status) {
      this.$emit('updateChildStatus', status);
    },
    handleUpdateChildStatus() {
      if (this.isUpdating) {
        return;
      }
      this.updateChildStatus(this.childStatus);
    },
  },
};
</script>
<style lang="scss" scoped>
@use '../../assets/scss/core/variables' as *;
@use '../../assets/scss/core/breakpoints' as *;
@use '../../assets/scss/components/presence/presence-checkin-dashboard' as *;
</style>
